export default "__VITE_ASSET__BNYyt_du__";